import React from 'react';

function AddUserDone() {
  return (
    <>
      <div className="register" style={{ display: 'flex', justifyContent: 'center' }}>
        <div style={{ textAlign: 'center' }}>
					<img src="check.png" alt="check" style={{ width: 72, height: 72}}/>
					<br />
					<br />
          <h3>인증이 완료되었습니다.</h3>
          <br />
          <label>고요한M 앱에서 비즈니스 연동 후 사용해 주세요.</label>
					<br />
					<br />
					<br />
					<h4>고요한M 다운로드</h4>
					<img src="qr.png" alt="QR Code" />
        </div>
      </div>
    </>
  );
}

export default AddUserDone;
